export default {
    ALREADY_EXISTS: 'Ya existe un gremio con ese nombre.',
    ALREADY_IN_GUILD: 'Ya estás en un gremio.',
    CANNOT_KICK_YOURSELF: 'No puedes expulsarte a ti mismo del gremio.',
    GUILD_FULL: 'Este gremio está al máximo de su capacidad.',
    MUST_FINISH_TUTORIAL_CREATE: 'Debes terminar el tutorial antes de poder crear un gremio.',
    NO_PERMISSION: 'No tienes permiso para hacer eso.',
    NO_PERMISSION_RANK: 'No tienes permiso para actualizar el rango de ese miembro.',
    NOT_ENOUGH_GOLD: 'Necesitas 30 000 de oro en tu inventario para crear un gremio.',
    NOT_ALLOWED_GUESTS_JOIN: 'Los invitados no pueden unirse a los gremios.',
    NOT_ALLOWED_GUESTS_CREATE: 'Los invitados no pueden crear gremios.'
} as const;
